import type { ReactNode } from 'react';

export const symbol_open_in_browser: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H600q-13 0-21.5-8.5T570-150q0-13 8.5-21.5T600-180h180v-540H180v540h180q13 0 21.5 8.5T390-150q0 13-8.5 21.5T360-120H180Zm270-30v-254l-62 62q-9 9-21 9t-21-9q-9-9-9-21.5t9-21.5l113-114q5-5 10-7t11-2q6 0 11 2t10 7l114 114q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9l-62-61v254q0 13-8.5 21.5T480-120q-13 0-21.5-8.5T450-150Z"
		/>
	</svg>
);
